<template>
  <div class="nav-page">
    <button class="btn-add" @click="openDialog()">添加导航</button>
    <table class="nav-table" border="1" cellpadding="8" cellspacing="0">
      <thead>
        <tr>
          <th>ID</th>
          <th>导航名称</th>
          <th>导航图片</th>
          <th>排序</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in tableData" :key="item.id">
          <td>{{item.id}}</td>
          <td>{{item.name}}</td>
          <td>
            <img :src="getImageUrl(item.img)" class="nav-img">
          </td>
          <td>{{item.sort}}</td>
          <td>
            <button class="btn-detail" @click="goDetail(item)">详情</button>
            <button class="btn-edit" @click="openDialog(item)">编辑</button>
            <button class="btn-del" @click="handleDelete(item.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 弹窗：新增/编辑导航 -->
    <div v-if="dialogVisible" class="dialog-mask" @click.self="dialogVisible=false">
      <div class="dialog-box">
        <h3 class="dialog-title">{{ form.id ? '编辑导航' : '添加导航' }}</h3>
        <div class="form-item">
          <label>导航名称：</label>
          <input class="input-text" v-model="form.name" type="text" />
        </div>
        <div class="form-item">
          <label>排序数字：</label>
          <input class="input-text" v-model.number="form.sort" type="number" />
        </div>
        <div class="form-item">
          <label>导航图片：</label>
          <input ref="fileInput" type="file" accept="image/*" @change="handleFileChange" />
          <img v-if="previewUrl" :src="previewUrl" class="preview-img" />
        </div>
        <div class="dialog-buttons">
          <button class="btn-cancel" @click="dialogVisible=false">取消</button>
          <button class="btn-save" @click="submitForm">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImageUrl } from '@/config.js'
export default {
  name: "NavManage",
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      previewUrl: "", // 图片预览地址
      form: {
        id: "",
        name: "",
        sort: 0,
        rawFile: null // 选中的图片文件对象
      }
    };
  },
  mounted() {
    this.getNavList();
  },
  methods: {
    // 获取导航列表
    async getNavList() {
      // 普通表单参数，不是json，不是FormData
      const res = await this.$request.post("action.php", "act=getNavList", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if (res.code === 200) {
        this.tableData = res.data;
      }
    },
    getImageUrl(path){
      return getImageUrl(path)
    },
    // 选择图片，生成预览
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.form.rawFile = file;
      // 本地预览图片
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    // 跳转到详情编辑页
    goDetail(item) {
      this.$router.push(`/admin/navDetail?id=${item.id}&name=${encodeURIComponent(item.name)}`)
    },
    // 打开弹窗 新增/编辑
    openDialog(row = null) {
      this.dialogVisible = true;
      this.form = {
        id: "",
        name: "",
        sort: 0,
        rawFile: null
      };
      this.previewUrl = "";
      this.$nextTick(() => {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
      });
      if (row) {
        this.form.id = row.id;
        this.form.name = row.name;
        this.form.sort = row.sort;
        if (row.img) {
          this.previewUrl = getImageUrl(row.img);
        }
      }
    },
    // 提交保存
    async submitForm() {
      // 前端校验
      if (!this.form.name) {
        alert("请填写导航名称");
        return;
      }
      // 新增必须上传图片
      if (!this.form.id && !this.form.rawFile) {
        alert("新增导航必须上传导航图片！");
        return;
      }
      // 构造FormData，上传图片必须用这个
      const formData = new FormData();
      formData.append("act", "saveNav");
      formData.append("name", this.form.name);
      formData.append("sort", this.form.sort);
      if (this.form.id) {
        formData.append("id", this.form.id);
      }
      // 有图片才传给后端，字段名 imgfile（不要改！）
      if (this.form.rawFile) {
        formData.append("imgfile", this.form.rawFile);
      }
      const res = await this.$request.post("action.php", formData);
      if (res.code === 200) {
        alert("保存成功");
        this.dialogVisible = false;
        this.getNavList();
      } else {
        alert(res.msg);
      }
    },
    // 删除导航
    async handleDelete(id) {
      if (!confirm("确定删除该导航？图片会一起删除")) return;
      const res = await this.$request.post("action.php", `act=delNav&id=${id}`, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if (res.code === 200) {
        alert("删除成功");
        this.getNavList();
      } else {
        alert(res.msg);
      }
    }
  }
};
</script>
<style scoped>
.nav-page {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 40px);
}
.btn-add {
  background: #409eff;
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.2s;
}
.btn-add:hover {
  background: #337ecc;
}
.nav-table {
  width: 100%;
  margin-top: 20px;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}
.nav-table th {
  background: #fafafa;
  padding:12px 8px;
  font-weight: 600;
}
.nav-table td {
  padding:12px 8px;
  border:1px solid #ebeef5;
}
.nav-table tbody tr:hover{
  background-color: #f5f7fa;
}
.nav-img{
  width:80px;
  height:80px;
  object-fit:cover;
  border-radius:4px;
}
.btn-detail{
  background:#409eff;
  color:#fff;
  border:none;
  padding:5px 10px;
  border-radius:4px;
  cursor:pointer;
  margin-right:6px;
}
.btn-edit{
  background:#67c23a;
  color:#fff;
  border:none;
  padding:5px 10px;
  border-radius:4px;
  cursor:pointer;
  margin-right:6px;
}
.btn-del{
  background:#f56c6c;
  color:#fff;
  border:none;
  padding:5px 10px;
  border-radius:4px;
  cursor:pointer;
}
/*弹窗遮罩*/
.dialog-mask{
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background:rgba(0,0,0,0.5);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:999;
}
.dialog-box{
  background:#fff;
  width:440px;
  padding:24px;
  border-radius:10px;
  box-shadow:0 4px 20px rgba(0,0,0,0.15);
}
.dialog-title{
  font-size:18px;
  margin:0 0 20px 0;
}
.form-item{
  margin-bottom:18px;
}
.form-item label{
  display:inline-block;
  width:90px;
}
.input-text{
  width:240px;
  padding:8px 10px;
  border:1px solid #dcdfe6;
  border-radius:4px;
  outline:none;
}
.input-text:focus{
  border-color:#409eff;
}
.preview-img{
  width:80px;
  height:80px;
  object-fit:cover;
  margin-top:8px;
  border-radius:4px;
}
.dialog-buttons{
  margin-top:24px;
  text-align:right;
}
.btn-cancel{
  border:1px solid #dcdfe6;
  background:#fff;
  padding:8px 16px;
  border-radius:4px;
  cursor:pointer;
  margin-right:10px;
}
.btn-save{
  background:#409eff;
  color:#fff;
  border:none;
  padding:8px 16px;
  border-radius:4px;
  cursor:pointer;
}
</style>
